var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import * as React from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { VehicleSpecs } from './components/VehicleSpecs';
import { VehicleAccessories } from './components/VehicleAccessories';
import { VehicleServicePackages } from './components/VehicleServicePackages';
import { VehicleComments } from './components/VehicleComments';
import { VehicleWarranty } from './components/VehicleWarranty';
import { VehicleTitle } from './components/VehicleTitle';
import { VehicleCTA } from './components/VehicleCTA';
import { VehicleEstablishment } from './components/VehicleEstablishment';
import GrainTrackingService, { EVENT_TYPE, APP_MODULE } from '../../shared/services/tracking.service';
import { VmGallery, VmIcon } from '@vanmossel-ui/react';
function DetailPage() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const [isLoading, setIsLoading] = React.useState(true);
    const [vehicleData, setVehicleData] = React.useState();
    const [establishment, setEstablishment] = React.useState();
    const container = document.querySelector('.js-elastic-voorraad');
    const feed = container.dataset.feedDetail;
    const environment = container.dataset.environment;
    const slug = window.location.pathname.split('/s/')[1];
    const vehicleFeed = feed.replace('[ID]', slug.split('-')[0]);
    const Voertuig = vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.Voertuig;
    const vehicleImages = (vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.Voertuig.Afbeeldingen) ? vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.Voertuig.Afbeeldingen : [];
    const galleryMainImage = [];
    if (vehicleImages.length) {
        galleryMainImage.push({
            url: vehicleImages[0].FullImgURL,
            thumbUrl: vehicleImages[0].ThumbLargeImgURL ? vehicleImages[0].ThumbLargeImgURL : vehicleImages[0].FullImgURL,
        });
    }
    const galleryThumbs = [];
    vehicleImages.slice(1).forEach((image) => {
        galleryThumbs.push({
            url: image.FullImgURL,
            thumbUrl: image.SliderThumb ? image.SliderThumb : image.FullImgURL,
        });
    });
    const previousSupplyFiltersQueryString = React.useRef(sessionStorage.getItem('supplyFilter'));
    React.useEffect(() => {
        setIsLoading(true);
        const fetchData = () => __awaiter(this, void 0, void 0, function* () {
            let vehicleResponse = null;
            try {
                vehicleResponse = yield fetch(vehicleFeed);
            }
            catch (e) {
                console.error(e);
                setIsLoading(false);
            }
            if (vehicleResponse) {
                const vehicleData = yield vehicleResponse.json();
                let establishmentApiUrlType = '';
                if (environment === 'dev') {
                    establishmentApiUrlType = 'https://vanmosselv2-corporate.vanmossel.com/api/v1/establishment';
                }
                else {
                    establishmentApiUrlType = 'https://api.vanmossel.com/api/v1/establishment';
                }
                const establishmentApiUrl = [
                    establishmentApiUrlType,
                    (vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.Voertuig.EstablishmentID)
                        ? `/${vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.Voertuig.EstablishmentID}`
                        : `/hexon/${vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.Voertuig.HexonVoorraadLijstID}`,
                    `?l=nl_NL`,
                ].join('');
                const getEstablishment = Promise.resolve(fetch(establishmentApiUrl)
                    .then((data) => data.json())
                    .then((data) => (data.statusCode === 200 ? data.result : undefined))
                    .catch((e) => {
                    console.log(e);
                    return undefined;
                }));
                const [establishmentData] = yield Promise.all([getEstablishment]);
                setVehicleData(vehicleData);
                setEstablishment(establishmentData);
                setIsLoading(false);
                GrainTrackingService.track({
                    event: EVENT_TYPE.VEHICLE_DISPLAY,
                    data: {
                        applicatieModule: APP_MODULE.MAXUS,
                        voertuigId: vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.Voertuig.ID,
                        autoMerk: vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.Voertuig.merk,
                        autoModel: vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.Voertuig.modelH,
                        voertuigBrandstof: vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.Voertuig.brandstof,
                        voertuigType: vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.Voertuig.carrosserie,
                    },
                    push: () => { },
                });
            }
        });
        fetchData();
    }, [slug]);
    useEffect(() => {
        const handlePopstate = () => {
            window.location.reload();
        };
        window.addEventListener('popstate', handlePopstate);
        return () => {
            window.removeEventListener('popstate', handlePopstate);
        };
    }, []);
    useEffect(() => {
        sessionStorage.removeItem('supplyFilter');
    }, []);
    if (isLoading) {
        return _jsx("div", { children: "Loading..." });
    }
    if (!vehicleData || !Voertuig) {
        return (_jsx("div", { className: "row", children: _jsxs("div", { className: "col-12", children: [_jsx("h1", { children: "Geen voertuig gevonden" }), _jsx("p", { children: "Klik op de onderstaande knop om terug te gaan naar het overzicht" }), _jsxs(Link, { className: "button button--ghost button--icon", to: {
                            pathname: '/',
                            search: previousSupplyFiltersQueryString.current
                                ? '?' + previousSupplyFiltersQueryString.current
                                : undefined,
                        }, children: [_jsx(VmIcon, { icon: "arrow-left-circle", solid: true }), "Terug naar overzicht"] })] }) }));
    }
    return (_jsxs("div", { className: "row", children: [_jsx("div", { className: "col-12 mb-3", children: _jsxs(Link, { className: "button button--ghost button--icon", to: {
                        pathname: '/',
                        search: previousSupplyFiltersQueryString.current
                            ? '?' + previousSupplyFiltersQueryString.current
                            : undefined,
                    }, children: [_jsx(VmIcon, { icon: "arrow-left-circle", solid: true }), "Terug naar overzicht"] }) }), _jsxs("div", { className: "col-lg-7", children: [_jsx(VmGallery, { mainImage: galleryMainImage, thumbs: galleryThumbs, className: "mb-3" }), _jsxs("div", { className: "d-lg-none", children: [_jsx(VehicleTitle, { merk: Voertuig.merk, modelH: Voertuig.modelH, type: Voertuig.type }), _jsx(VehicleCTA, { VanPrijs: Voertuig.VanPrijs, kenteken: Voertuig.kenteken, model: Voertuig.modelH, establishmentID: establishment === null || establishment === void 0 ? void 0 : establishment.id, establishmentTitle: establishment === null || establishment === void 0 ? void 0 : establishment.title, hexonID: Voertuig.ID }), _jsx(VehicleEstablishment, { establishment: establishment, vehicleBrand: Voertuig.merk })] }), _jsx(VehicleSpecs, { voertuig: Voertuig }), _jsx(VehicleAccessories, { accessoiregroepen: (_a = Voertuig.Hexon) === null || _a === void 0 ? void 0 : _a.accessoiregroepen, accessoiregroepen_frans: (_b = Voertuig.Hexon) === null || _b === void 0 ? void 0 : _b.accessoiregroepen_frans, extraOptions: Voertuig.ExtraOptions }), _jsx(VehicleServicePackages, { afleverpakketten: (_c = Voertuig.Hexon) === null || _c === void 0 ? void 0 : _c.afleverpakketten }), _jsx(VehicleComments, { opmerkingen: (_d = Voertuig.Hexon) === null || _d === void 0 ? void 0 : _d.opmerkingen, opmerkingen_frans: (_e = Voertuig.Hexon) === null || _e === void 0 ? void 0 : _e.opmerkingen_frans }), _jsx(VehicleWarranty, { garantie_maanden: (_f = Voertuig.Hexon) === null || _f === void 0 ? void 0 : _f.garantie_maanden, fabrieksgarantie_tot: (_g = Voertuig.Hexon) === null || _g === void 0 ? void 0 : _g.fabrieksgarantie_tot, opmerkingen_garantie: (_h = Voertuig.Hexon) === null || _h === void 0 ? void 0 : _h.opmerkingen_garantie, bovag_garantie: (_j = Voertuig.Hexon) === null || _j === void 0 ? void 0 : _j.bovag_garantie, merkgarantie: (_k = Voertuig.Hexon) === null || _k === void 0 ? void 0 : _k.merkgarantie })] }), _jsxs("div", { className: "col-lg-5 d-lg-block d-none", children: [_jsx(VehicleTitle, { merk: Voertuig.merk, modelH: Voertuig.modelH, type: Voertuig.type }), _jsx(VehicleCTA, { VanPrijs: Voertuig.VanPrijs, kenteken: Voertuig.kenteken, model: Voertuig.modelH, establishmentID: establishment === null || establishment === void 0 ? void 0 : establishment.id, establishmentTitle: establishment === null || establishment === void 0 ? void 0 : establishment.title, hexonID: Voertuig.ID, price_is_ex_btw: Voertuig.price_is_ex_btw }), _jsx(VehicleEstablishment, { establishment: establishment, vehicleBrand: Voertuig.merk })] })] }));
}
export { DetailPage as default };
